export default {
  "overviewTitle": "会员数据概览",
  "core": "核心指标",
  "change": "环比",
  "noPrevious": "暂无上月数据",
  "trendTitle": "近 6 个月会员收入趋势",
  "topTitle": "Top 10 开通会员企业",
  "rank": "排名",
  "company": "企业 / 组织",
  "plan": "会员套餐",
  "amount": "开通金额",
  "emptyOrders": "暂无会员开通记录",
  "planDistribution": "会员套餐售卖分布",
  "planCenter": "套餐\n占比",
  "sourceDistribution": "会员来源分布",
  "sourceCenter": "开通\n来源",
  "statusDistribution": "会员状态分布",
  "statusCenter": "会员\n状态",
  "newMembers": "本月新增会员",
  "monthRevenue": "本月会员收入",
  "activatedCompanies": "本月开通企业",
  "totalRevenue": "累计会员收入",
  "premium": "高级会员数",
  "customMembers": "定制会员数",
  "soon": "即将到期(30天内)",
  "average": "平均客单价",
  "defaultPlan": "默认套餐",
  "custom": "定制",
  "defaultDescription": "适合不同规模的会务活动组织使用。",
  "free": "免费",
  "permanentValid": "永久有效",
  "quotas": "资源配额",
  "activities": "活动",
  "albums": "照片直播",
  "forms": "问卷",
  "donations": "捐款",
  "nameCards": "名片",
  "storage": "云存储",
  "sms": "短信",
  "logo": "底部 Logo",
  "customLogo": "自定义",
  "defaultLogo": "平台默认",
  "features": "包含功能",
  "emptyFeatures": "暂无额外功能",
  "editPlan": "编辑套餐",
  "subscribers": "查看订阅用户",
  "delete": "删除",
  "emptyPlans": "暂无套餐",
  "category": "套餐分类",
  "platformCategory": "平台套餐（官网 / 企业 / 对接人公开售卖）",
  "customCategory": "定制套餐（定向邀请开通）",
  "basic": "基本信息",
  "permanent": "永久",
  "limited": "限期",
  "daysPlaceholder": "天数",
  "days": "天",
  "zeroUnlimited": "填写 0 表示不限",
  "onePerLine": "每行一项",
  "remark": "套餐备注",
  "remarkPlaceholder": "展示在套餐卡片底部的补充说明",
  "cancel": "取消",
  "memberNo": "会员编号",
  "companyName": "企业/组织名称",
  "contact": "联系人",
  "phone": "手机号",
  "expires": "到期时间",
  "eventsCreated": "已建活动",
  "status": "状态",
  "expired": "已到期",
  "active": "正常",
  "actions": "操作",
  "details": "查看详情",
  "close": "关闭",
  "unlimited": "不限",
  "saved": "套餐已保存",
  "saveFailed": "套餐保存失败，请稍后重试",
  "deleteTitle": "删除套餐",
  "deleted": "套餐已删除",
  "verification": "认证类别",
  "enterprise": "组织认证",
  "personal": "个人认证",
  "buyout": "（永久买断）",
  "guide": "会员套餐分两类：平台套餐面向官网 / 企业使用者 / 对接人视角公开售卖；定制套餐面向大中型企业的定向需求，配置专属资源配额后生成开通链接、邀请对应企业开通。修改后实时生效，请谨慎操作",
  "trendNote": "单位：元 · 峰值 {amount}",
  "companyCount": "{n} 家",
  "validDays": "{n} 天有效",
  "subscriberTitle": "订阅用户 · {name}",
  "subscriberCount": "共 {n} 家企业订阅",
  "deleteConfirm": "确认删除套餐“{name}”吗？",
  "sourceSelf": "官网自助开通",
  "sourceProxy": "对接人邀请开通",
  "sourceEnterprise": "企业使用者推荐",
  "normalMembers": "普通会员",
  "customMemberLabel": "定制会员",
  "nameRequired": "请输入套餐名称"
}
